import { ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Input, NgZone, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { empty, Subject } from 'rxjs';
import { Menssage } from './message.model';
import * as moment from 'moment';
import { ChatService } from './chat.service';
import { SuccessDialogComponent } from 'src/app/modules/dialogs/success_dialog/success_dialog.component';
import { ErrorDialogComponent } from 'src/app/modules/dialogs/error_dialog/error_dialog.component';
import { BasicDialogComponent } from 'src/app/modules/dialogs/basic_dialog/basic_dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'chat',
    templateUrl: './chat.component.html',
    styleUrls: ['./chat.component.scss']
  })

  export class ChatComponent implements  OnInit
  {
    @Input() room_id;
    @Input() client_id;
    @ViewChild('messageInput') messageInput: ElementRef;
    menssage: Menssage[];

    drawerMode: 'over' | 'side' = 'side';
    drawerOpened: boolean = false;
    private _unsubscribeAll: Subject<any> = new Subject<any>();
    @Output() flag_channel_whatsapp = new EventEmitter<boolean>();
    currentuser_id: number;
    next_page_number: boolean;
    num_pages: number;
    has_next: boolean;
    page:number;
    text;
    room;
    id_send;
    total_page;
    flag:boolean;
    avatar;
    format;
    intervalo;
    constructor(
      private cs: ChatService,
      private _ngZone: NgZone,
      private change: ChangeDetectorRef, 
      public dialog: MatDialog)
    {
        this.menssage= [];
        this.currentuser_id= 0;
        this.page=1;
        this.flag=false;
        this.format="";
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Decorated methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Resize on 'input' and 'ngModelChange' events
     *
     * @private
     */
     @HostListener('messageInput')
     @HostListener('ngModelChange')

     private _resizeMessageInput(): void
     {
         // This doesn't need to trigger Angular's change detection by itself
         this._ngZone.runOutsideAngular(() => {

             setTimeout(() => {

                 // Set the height to 'auto' so we can correctly read the scrollHeight
                 this.messageInput.nativeElement.style.height = 'auto';

                 // Detect the changes so the height is applied
                 this.change.detectChanges();

                 // Get the scrollHeight and subtract the vertical padding
                 this.messageInput.nativeElement.style.height = `${this.messageInput.nativeElement.scrollHeight}px`;

                 // Detect the changes one more time to apply the final height
                 this.change.detectChanges();
             });
         });
     }

     // -----------------------------------------------------------------------------------------------------
     // @ Lifecycle hooks
     // -----------------------------------------------------------------------------------------------------

     /**
      * On init
      */
     ngOnInit()
    {
        const buttonClose = document.querySelector('.btn-close') as HTMLButtonElement;
        if (document.documentElement.classList.contains('dark')) {
            buttonClose.style.setProperty('--bs-btn-close-bg', 
            `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23eaecef'%3e%3cpath d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z'/%3e%3c/svg%3e")`);
        }

        this.menssage = [];
        this.currentuser_id = Number(localStorage.getItem('user'));

        this.loadMessages();

        this.intervalo= setInterval(()=>{
            this.loadMessages()},20000)
    }

    ngOnDestroy(): void {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        clearInterval(this.intervalo)
    }

    /*
        Function for capture the keyword
    */

    enterpress(event)
    {
        if(event['key']=='Enter')
        {
            if(this.text!= undefined || this.text != null)
            {
                if(this.text!= '')
                {
                    this.insert();
                    event.preventDefault()
                }
            }
            else{
                event.preventDefault()
            }
        }
    }

     /*
        Insert new message
     */
    insert(): void
    {

        var object= {
            'room_id':this.room,
            'user_id': JSON.parse(localStorage.getItem('user')),
            'message': this.text
        }

        if(this.text!= undefined)
        {

            if(this.text!= '')
            {
                this.cs.postMenssage(object).subscribe(data=>{})
                this.text="";
                // this.menssage = [];
            }
            this.loadMessages();
        }

    }

    /**
     * Track by function for ngFor loops
     *
     * @param index
     * @param item
     */
    trackByFn(index: number, item: any): any
    {
        return item.id || index;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['room_id'] && !changes['room_id'].firstChange) {
            /* this.selectedRow = changes['selectedRow'].currentValue; */
            this.resetChat();
        }
    }

    resetChat(): void {
        this.menssage = [];
        this.room = undefined;
        this.loadMessages();
    }

    async loadMessages()
    {
        // this.menssage=[];

        // let x= await this.cs.getRoom(this.selectedRow['client_ia__user_profile_ia__user_ia__pk'], this.selectedRow['installation_ia__installer_ia__user_profile_ia__user_ia__pk']).toPromise();
        // let newRoom = x[0]['room_ia_id'];
        let newRoom = this.room_id
        if (this.room !== newRoom) {
            this.room = newRoom;
            this.menssage = [];
        }

        let pages= await this.cs.getChat(this.room,this.page).toPromise();

        this.total_page=pages['num_pages']
        this.flag_channel_whatsapp.emit(pages['whatsapp_channel'])
        // this.menssage=[];
        if(this.total_page==1)
        {
            const response = await this.cs.getChat(this.room,1).toPromise();
            // this.menssage=[];
            response['chats'].forEach(element => {
                let date = moment.utc(element['datetime'], "MM-DD-yyyy, hh:mm:ss")
                element['datetime'] = date.format()
                if (this.menssage.findIndex(message => message.id == element.id) < 0) {
                    this.menssage.push(element);
                }
            });
        }
        else
        {
            for (let i=0; i < this.total_page; i++)
            {
                const response = await this.cs.getChat(this.room,i+1).toPromise();
                response['chats'].forEach(element => {
                    let date = moment.utc(element['datetime'], "MM-DD-yyyy, hh:mm:ss")
                    element['datetime'] = date.format()
                    if (this.menssage.findIndex(message => message.id == element.id) < 0) {
                        this.menssage.push(element);
                    }
                });
            }
        }
    }

    openFileSelector() {
        const input = document.createElement('input');
        input.type = 'file';
        input.accept = '.pdf, image/*';

        input.onchange = (event: any) => {
            const file = event.target.files[0];
            if (file) {
                this.uploadFile(file);
            }
        };
        input.click();
    }

    // Función para establecer el z-index del offcanvas
    private setChatOffcanvasZIndex(value: string): void {
        const offcanvas = document.getElementById('offcanvasChat') as HTMLElement;

            if (offcanvas) {
                offcanvas.style.zIndex = value;
        }
    }

    uploadFile(file: File) {
        this.setChatOffcanvasZIndex('1000');

        const dialogRef = this.dialog.open(BasicDialogComponent, {
            autoFocus: false,
            restoreFocus: false,
            panelClass: 'no-padding-dialog',
            data: {
            title: 'Subir archivo',
            content: '¿Estás seguro de que quieres subir este archivo?',
            buttons: [
                { label: 'Cancelar', action: 'cancel' },
                { label: 'Sí, Subir Archivo', action: 'yes' }
            ]
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result?.return !== 'success') {
                this.setChatOffcanvasZIndex('1045');
                return;
            }

            this.cs.postFileToWhatsapp(file, 'FTP', this.client_id).subscribe({
                next: () => {
                    this.setChatOffcanvasZIndex('1000');

                    const successRef = this.dialog.open(SuccessDialogComponent, {
                        autoFocus: false,
                        restoreFocus: false,
                        panelClass: 'no-padding-dialog',
                        data: {
                            title: 'Archivo subido',
                            content: 'El archivo se ha subido correctamente.',
                            buttons: [{ label: 'Aceptar', action: 'ok' }]
                        }
                    });

                    successRef.afterClosed().subscribe(() => {
                        this.setChatOffcanvasZIndex('1045');
                        this.loadMessages();
                    });
                },
                error: () => {
                    this.setChatOffcanvasZIndex('1000');

                    const errorRef = this.dialog.open(ErrorDialogComponent, {
                        autoFocus: false,
                        restoreFocus: false,
                        panelClass: 'no-padding-dialog',
                        data: {
                            title: 'Error',
                            content: 'Ha ocurrido un error durante la subida del documento.',
                            buttons: [{ label: 'Aceptar', action: 'ok' }]
                        }
                    });

                    errorRef.afterClosed().subscribe(() => {
                        this.setChatOffcanvasZIndex('1045');
                    });
                }
            });
        });
    }
}
